import React,{Component}             from 'react';
import Step2BasicInfoForm            from './step2basicinfoform/Step2BasicInfoForm';
import { callables as StoreMethods } from 'app/store/Store';
import Helpers                       from 'app/utils/helpers/Helpers'; 
import Loader                        from 'app/components/loader/Loader';
import Model                 		 from 'app/modules/model/Model';
import GoogleAnalytics 				 from 'app/utils/googleanalytics/GoogleAnalytics';

class Step2 extends Component {

	constructor(props) {
		super(props);
		this.state  = { loading   : 1 };
	}

  	componentDidMount = () => {
		GoogleAnalytics.page_view([], 'Step 2');
  		this.check_loading();
  	}

  	componentDidUpdate = () => {
  		this.check_loading();
  	}

	render() {
		if (this.state.loading) {
			return <Loader.Spinner />;
		} else {
			return <Step2BasicInfoForm {...this.props}/>;
		} 
	}

	check_loading = () => {
		if (this.state.loading===1) {
			var has_Step = !Helpers.is_empty(this.props.Step);

  			if (has_Step) {
  				this.setState({ loading: 0 });
				if(this.checkStep8()){
					StoreMethods.step_enabled_change(8)
					this.changeDateSuccess()
					//this.disableAllandYa()
					//StoreMethods.step_enabled_change(8)
				}  
  			}
		}
	}
	//Added on 20220614---------
	checkStep8(){
		var done = false;
		var temp = StoreMethods.get_FormChange()
		var array = temp.StepReducers.content.previous_progress
		//console.log(temp,'step2')
		for (let index = 0; index < array.length; index++) {
			if(array[index]==='Regol Successful'){
				done = true;
				break;
			}
			
		}

		return done
	}

	disableAllandYa(){
		var temp = this.inputs
		for(var keys in temp){
			if(keys === 'accept_statement'){
				if(temp[keys].ref.current){
					temp[keys].ref.current.set_value(1)
					temp[keys].ref.current.disable()
				}
			}else{
				if(temp[keys].ref.current.disable()){
					temp[keys].ref.current.disable()
				}
			}

		}
	}

	changeDateSuccess(){
		var temp = StoreMethods.get_FormChange()
		var regSuc = temp.StepReducers.content.regol_sucessfull_date
		if(regSuc){
			this.changeTextDateSuccess('RealAccountComponentStyles-timer',regSuc)
		}
	}

	changeTextDateSuccess(classname,regSuc){
		//var add = add || false;
		var children = document.body.getElementsByTagName('*');
  		var child;
  		for (var i = 0, length = children.length; i < length; i++) {
    		child = children[i] || {};
			if(child.className){
				if (child.className === classname) {
					child.innerText = regSuc
					//console.log(child)
					
				}
			}
  		}
	}
}

export default StoreMethods.connect_stores(Step2, ['Step'], Model.get_realaccount_data);